import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { detectStore } from "@/shared/lib/platform"

registerNotification("chat_with_luni", {
	handle: ({ notification_id }) =>
		showNotification({
			type: "chat-with-luni",
			placement: "home",
			origin: "server",
			name: "chat_with_luni",
			notificationId: notification_id,
		}),
	route: () => ({ to: "/home" }),
	routePopup: null,
})

registerNotification("vpn", {
	handle: ({ notification_id, data }) => {
		// VPN скрыт в App Store и RuStore для прохождения review
		const store = detectStore()
		if (store === "app-store" || store === "rustore") return
		showNotification({
			type: "vpn",
			placement: "home",
			origin: "server",
			name: "vpn",
			notificationId: notification_id,
			vpnKey: data.vpn_key,
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})

registerNotification("email_backup", {
	handle: ({ notification_id }) =>
		showNotification({
			type: "email-backup",
			placement: "home",
			origin: "server",
			name: "email_backup",
			notificationId: notification_id,
		}),
	route: () => ({ to: "/home" }),
	routePopup: null,
})
